import React, {useState} from 'react';
import {IncidentListDTO} from 'hemwb-api';
import {useIncidentDetail} from '../../../../../../store/incident';
import styles from './IncidentOverview.module.scss';
import IncidentTextOverview from '../incidentTextOverview/IncidentTextOverview';
import IncidentWorkOverview from '../incidentWorkOverview/IncidentWorkOverview';

export type IncidentOverviewProps = {
  incident: IncidentListDTO;
};

const IncidentOverview: React.FC<IncidentOverviewProps> = ({incident}) => {
  const incidentDetail = useIncidentDetail(incident) || undefined;
  const [tab, setTab] = useState('details');

  return (
    <div className={styles.overviewContainer}>
      <div className={styles.tabBar}>
        <button
          type="button"
          className={`${styles.tabButton} ${tab === 'details' ? styles.tabButtonActive : ''}`}
          onClick={() => setTab('details')}
        >
          Details
        </button>
        <button
          type="button"
          className={`${styles.tabButton} ${tab === 'work' ? styles.tabButtonActive : ''}`}
          onClick={() => setTab('work')}
        >
          Worklog
        </button>
      </div>
      <div className={styles.contentArea}>
        {tab === 'details' && <IncidentTextOverview incident={incidentDetail || incident} />}
      </div>
      <div className={styles.contentArea}>
        {tab === 'work' && <IncidentWorkOverview incident={incidentDetail || incident} />}
      </div>
    </div>
  );
};

export default IncidentOverview;
